import React, { useEffect } from 'react'

const styles = `
.lottery-page {
  --green-dark: #1a6641;
  --green-mid:  #2e8c59;
  --green-light:#e6f4ed;
  --green-acc:  #3dba77;
  --gold:       #e8a320;
  --gold-light: #fff8e8;
  --ink:        #1c2b22;
  --muted:      #5a7265;
  --bg:         #f7faf8;
  --white:      #ffffff;
  --border:     #cce4d6;
  --radius:     12px;
  font-family: 'Noto Sans TC', sans-serif;
  background: var(--bg);
  color: var(--ink);
  line-height: 1.7;
  min-height: 100vh;
}
.lottery-page *, .lottery-page *::before, .lottery-page *::after { box-sizing: border-box; }

.lottery-page .hero {
  background: linear-gradient(135deg, var(--green-dark) 0%, var(--green-mid) 60%, #43c47e 100%);
  color: #fff;
  padding: 64px 24px 80px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.lottery-page .hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='30' cy='30' r='28' fill='none' stroke='rgba(255,255,255,0.06)' stroke-width='1'/%3E%3C/svg%3E") repeat;
}
.lottery-page .hero-badge {
  display: inline-block;
  background: rgba(255,255,255,0.18);
  border: 1px solid rgba(255,255,255,0.35);
  border-radius: 999px;
  padding: 5px 18px;
  font-size: 13px;
  letter-spacing: 0.08em;
  margin-bottom: 20px;
  backdrop-filter: blur(4px);
}
.lottery-page .hero h1 {
  font-size: clamp(28px, 6vw, 52px);
  font-weight: 900;
  line-height: 1.15;
  letter-spacing: -0.01em;
  margin-bottom: 12px;
}
.lottery-page .hero h1 span { color: #a8f0c6; }
.lottery-page .hero-sub {
  font-size: clamp(15px, 2.5vw, 18px);
  opacity: 0.88;
  max-width: 520px;
  margin: 0 auto 28px;
}
.lottery-page .hero-period {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 999px;
  padding: 10px 24px;
  font-size: 15px;
  font-weight: 700;
  backdrop-filter: blur(4px);
}
.lottery-page .hero-period .dot { width: 8px; height: 8px; background: #a8f0c6; border-radius: 50%; flex-shrink: 0; }

.lottery-page .wave {
  display: block;
  width: 100%;
  margin-top: -2px;
  color: var(--bg);
}

.lottery-page .container {
  max-width: 860px;
  margin: 0 auto;
  padding: 0 20px;
}

.lottery-page section { padding: 56px 0; }
.lottery-page section + section { border-top: 1px solid var(--border); }

.lottery-page .section-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--green-mid);
  margin-bottom: 12px;
}
.lottery-page .section-label::before {
  content: '';
  width: 20px;
  height: 2px;
  background: var(--green-acc);
  display: inline-block;
}
.lottery-page .section-title {
  font-size: clamp(22px, 4vw, 30px);
  font-weight: 900;
  margin-bottom: 28px;
  color: var(--ink);
}

.lottery-page .prize-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}
.lottery-page .prize-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 28px 16px;
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
}
.lottery-page .prize-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(46,140,89,0.12);
}
.lottery-page .prize-card.highlight {
  border-color: var(--gold);
  background: var(--gold-light);
}
.lottery-page .prize-card.highlight::after {
  content: '大獎';
  position: absolute;
  top: 12px; right: -22px;
  background: var(--gold);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 32px;
  transform: rotate(45deg);
  letter-spacing: 0.1em;
}
.lottery-page .prize-amount {
  font-size: 36px;
  font-weight: 900;
  color: var(--green-dark);
  line-height: 1;
  margin-bottom: 6px;
}
.lottery-page .prize-amount small { font-size: 16px; }
.lottery-page .prize-card.highlight .prize-amount { color: var(--gold); }
.lottery-page .prize-unit { font-size: 13px; color: var(--muted); margin-bottom: 12px; }
.lottery-page .prize-qty {
  display: inline-block;
  background: var(--green-light);
  color: var(--green-dark);
  font-size: 13px;
  font-weight: 700;
  padding: 4px 14px;
  border-radius: 999px;
}
.lottery-page .prize-card.highlight .prize-qty { background: #fdefc5; color: #9a6800; }
.lottery-page .prize-note {
  text-align: center;
  color: var(--muted);
  font-size: 14px;
  margin-top: 8px;
}

.lottery-page .steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}
.lottery-page .step-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 24px 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
}
.lottery-page .step-num {
  flex-shrink: 0;
  width: 38px; height: 38px;
  background: var(--green-dark);
  color: #fff;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 16px;
  font-weight: 900;
}
.lottery-page .step-card h3 { font-size: 15px; font-weight: 700; margin-bottom: 4px; }
.lottery-page .step-card p  { font-size: 13px; color: var(--muted); line-height: 1.55; }

.lottery-page .cal-wrap {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
}
.lottery-page .cal-header {
  background: var(--green-dark);
  color: #fff;
  padding: 16px 20px;
  font-weight: 700;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.lottery-page .cal-header svg { flex-shrink: 0; }
.lottery-page .cal-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.lottery-page .cal-dow {
  text-align: center;
  padding: 10px 4px;
  font-size: 12px;
  font-weight: 700;
  color: var(--muted);
  background: #f0f7f3;
  border-bottom: 1px solid var(--border);
}
.lottery-page .cal-day {
  min-height: 64px;
  padding: 8px 6px;
  border-right: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  font-size: 13px;
  font-weight: 500;
  color: var(--muted);
  position: relative;
}
.lottery-page .cal-day:nth-child(7n) { border-right: none; }
.lottery-page .cal-day.empty { background: #fafcfb; }
.lottery-page .cal-day.active { color: var(--ink); }
.lottery-page .cal-day.deadline { background: #fff0f0; }
.lottery-page .cal-day.announce { background: var(--green-light); }
.lottery-page .cal-day .day-num {
  display: block;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 4px;
}
.lottery-page .cal-tag {
  display: block;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 5px;
  border-radius: 4px;
  line-height: 1.4;
  margin-top: 2px;
}
.lottery-page .tag-deadline { background: #ffd5d5; color: #c0392b; }
.lottery-page .tag-announce { background: #c6edd9; color: var(--green-dark); }

.lottery-page .cal-legend {
  display: flex;
  gap: 20px;
  padding: 14px 20px;
  border-top: 1px solid var(--border);
  font-size: 13px;
  color: var(--muted);
  flex-wrap: wrap;
}
.lottery-page .cal-legend span { display: flex; align-items: center; gap: 6px; }
.lottery-page .legend-dot { width: 12px; height: 12px; border-radius: 3px; flex-shrink: 0; }

.lottery-page .claim-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.lottery-page .claim-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 22px 20px;
}
.lottery-page .claim-icon { font-size: 28px; margin-bottom: 10px; }
.lottery-page .claim-card h3 { font-size: 15px; font-weight: 700; margin-bottom: 6px; }
.lottery-page .claim-card p  { font-size: 13px; color: var(--muted); line-height: 1.6; }

.lottery-page .notice-list {
  list-style: none;
  display: grid;
  gap: 12px;
  padding: 0;
}
.lottery-page .notice-list li {
  background: var(--white);
  border: 1px solid var(--border);
  border-left: 4px solid var(--green-acc);
  border-radius: 0 var(--radius) var(--radius) 0;
  padding: 14px 18px;
  font-size: 14px;
  color: var(--ink);
  line-height: 1.65;
}

.lottery-page .sms-box {
  background: #fffbf0;
  border: 1px solid #f0d890;
  border-radius: var(--radius);
  padding: 24px;
}
.lottery-page .sms-box h3 { font-size: 15px; font-weight: 700; margin-bottom: 14px; color: #7a5c00; }
.lottery-page .sms-tips { list-style: none; display: grid; gap: 8px; padding: 0; }
.lottery-page .sms-tips li {
  font-size: 13px;
  color: #5a4400;
  display: flex;
  gap: 8px;
  line-height: 1.55;
}
.lottery-page .sms-tips li::before { content: '▸'; color: var(--gold); flex-shrink: 0; margin-top: 1px; }

.lottery-page .organizer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}
.lottery-page .org-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 20px;
}
.lottery-page .org-role { font-size: 11px; font-weight: 700; color: var(--green-mid); letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 6px; }
.lottery-page .org-name { font-size: 16px; font-weight: 700; }
.lottery-page .org-phone { margin-top: 8px; font-size: 13px; color: var(--muted); }
.lottery-page .org-phone a { color: var(--green-mid); text-decoration: none; font-weight: 700; }

.lottery-page footer {
  background: var(--green-dark);
  color: rgba(255,255,255,0.7);
  text-align: center;
  padding: 28px 20px;
  font-size: 13px;
}
.lottery-page footer strong { color: #fff; }

@media (max-width: 600px) {
  .lottery-page .prize-grid { grid-template-columns: 1fr; }
  .lottery-page .claim-grid { grid-template-columns: 1fr; }
  .lottery-page .cal-day { min-height: 52px; padding: 6px 4px; }
  .lottery-page .cal-day .day-num { font-size: 12px; }
  .lottery-page .cal-tag { font-size: 9px; }
  .lottery-page section { padding: 40px 0; }
}
`

const Lottery = () => {
  useEffect(() => {
    const linkPreconnect = document.createElement('link')
    linkPreconnect.rel = 'preconnect'
    linkPreconnect.href = 'https://fonts.googleapis.com'
    const linkFont = document.createElement('link')
    linkFont.rel = 'stylesheet'
    linkFont.href =
      'https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700;900&display=swap'
    document.head.appendChild(linkPreconnect)
    document.head.appendChild(linkFont)
    return () => {
      document.head.removeChild(linkPreconnect)
      document.head.removeChild(linkFont)
    }
  }, [])

  return (
    <div className="lottery-page">
      <style>{styles}</style>

      <header className="hero">
        <div className="hero-badge">衛生福利部國民健康署</div>
        <h1>
          填問卷<span>週週抽</span>
          <br />
          好禮送不停
        </h1>
        <p className="hero-sub">
          國民健康署不僅關心大家的身體健康，也關心大家的情緒開心 💚
        </p>
        <p
          className="hero-sub"
          style={{
            opacity: 0.78,
            fontSize: 'clamp(13px,2vw,16px)',
            marginTop: '-16px',
          }}
        >
          填完問卷，除了可以抽當週獎勵之外，後續每一週也可以繼續抽！
        </p>
        <div className="hero-period">
          <span className="dot"></span>
          活動期間：115年 7月1日 ─ 8月9日
        </div>
      </header>

      <svg
        className="wave"
        viewBox="0 0 1440 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          d="M0 48V24C360 0 720 0 1080 24C1260 36 1380 42 1440 44V48H0Z"
          fill="var(--bg)"
        />
      </svg>

      <section>
        <div className="container">
          <div className="section-label">參與方式</div>
          <h2 className="section-title">三步驟，輕鬆參與抽獎</h2>
          <div className="steps">
            <div className="step-card">
              <div className="step-num">1</div>
              <div>
                <h3>完成問卷</h3>
                <p>
                  於活動期間填寫「國民健康混合模式訪問調查」網路問卷，每人限填乙份。
                </p>
              </div>
            </div>
            <div className="step-card">
              <div className="step-num">2</div>
              <div>
                <h3>週日前送出</h3>
                <p>於週日 23:59 前完成填答，即取得隔週三抽獎資格。</p>
              </div>
            </div>
            <div className="step-card">
              <div className="step-num">3</div>
              <div>
                <h3>持續參與</h3>
                <p>填一次問卷，自動加入所有梯次抽獎。中獎後資格仍保留，可繼續抽！</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="section-label">獎品介紹</div>
          <h2 className="section-title">每週 75 份超商電子禮品卡</h2>
          <div className="prize-grid">
            <div className="prize-card">
              <div className="prize-amount">
                <small>$</small>200
              </div>
              <div className="prize-unit">四大超商電子商品卡</div>
              <div className="prize-qty">每週 50 份</div>
            </div>
            <div className="prize-card">
              <div className="prize-amount">
                <small>$</small>500
              </div>
              <div className="prize-unit">四大超商電子商品卡</div>
              <div className="prize-qty">每週 20 份</div>
            </div>
            <div className="prize-card highlight">
              <div className="prize-amount">
                <small>$</small>1,000
              </div>
              <div className="prize-unit">四大超商電子商品卡</div>
              <div className="prize-qty">每週 5 份</div>
            </div>
          </div>
          <p className="prize-note">
            得獎後透過手機簡訊或 EMAIL 直接發送，不需親自領取 🎉
          </p>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="section-label">抽獎時程</div>
          <h2 className="section-title">週週抽日曆</h2>
          <div className="cal-wrap">
            <div className="cal-header">
              <svg
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <path d="M16 2v4M8 2v4M3 10h18" />
              </svg>
              115年 7月 ─ 8月
            </div>
            <div className="cal-grid">
              <div className="cal-dow">一</div>
              <div className="cal-dow">二</div>
              <div className="cal-dow">三</div>
              <div className="cal-dow">四</div>
              <div className="cal-dow">五</div>
              <div className="cal-dow">六</div>
              <div className="cal-dow">日</div>

              <div className="cal-day empty"></div>
              <div className="cal-day empty"></div>
              <div className="cal-day active">
                <span className="day-num">7/1</span>
                <span
                  className="cal-tag"
                  style={{ background: '#d4eee0', color: '#1a6641', fontSize: '9px' }}
                >
                  活動開始
                </span>
              </div>
              <div className="cal-day active"><span className="day-num">2</span></div>
              <div className="cal-day active"><span className="day-num">3</span></div>
              <div className="cal-day active"><span className="day-num">4</span></div>
              <div className="cal-day active"><span className="day-num">5</span></div>

              <div className="cal-day active"><span className="day-num">6</span></div>
              <div className="cal-day active"><span className="day-num">7</span></div>
              <div className="cal-day active"><span className="day-num">8</span></div>
              <div className="cal-day active"><span className="day-num">9</span></div>
              <div className="cal-day active"><span className="day-num">10</span></div>
              <div className="cal-day active"><span className="day-num">11</span></div>
              <div className="cal-day deadline">
                <span className="day-num">12</span>
                <span className="cal-tag tag-deadline">第1週截止</span>
              </div>

              <div className="cal-day active"><span className="day-num">13</span></div>
              <div className="cal-day active"><span className="day-num">14</span></div>
              <div className="cal-day announce">
                <span className="day-num">15</span>
                <span className="cal-tag tag-announce">公告第1週</span>
              </div>
              <div className="cal-day active"><span className="day-num">16</span></div>
              <div className="cal-day active"><span className="day-num">17</span></div>
              <div className="cal-day active"><span className="day-num">18</span></div>
              <div className="cal-day deadline">
                <span className="day-num">19</span>
                <span className="cal-tag tag-deadline">第2週截止</span>
              </div>

              <div className="cal-day active"><span className="day-num">20</span></div>
              <div className="cal-day active"><span className="day-num">21</span></div>
              <div className="cal-day announce">
                <span className="day-num">22</span>
                <span className="cal-tag tag-announce">公告第2週</span>
              </div>
              <div className="cal-day active"><span className="day-num">23</span></div>
              <div className="cal-day active"><span className="day-num">24</span></div>
              <div className="cal-day active"><span className="day-num">25</span></div>
              <div className="cal-day deadline">
                <span className="day-num">26</span>
                <span className="cal-tag tag-deadline">第3週截止</span>
              </div>

              <div className="cal-day active"><span className="day-num">27</span></div>
              <div className="cal-day active"><span className="day-num">28</span></div>
              <div className="cal-day announce">
                <span className="day-num">29</span>
                <span className="cal-tag tag-announce">公告第3週</span>
              </div>
              <div className="cal-day active"><span className="day-num">30</span></div>
              <div className="cal-day active"><span className="day-num">31</span></div>
              <div className="cal-day active"><span className="day-num">8/1</span></div>
              <div className="cal-day deadline">
                <span className="day-num">2</span>
                <span className="cal-tag tag-deadline">第4週截止</span>
              </div>

              <div className="cal-day active"><span className="day-num">3</span></div>
              <div className="cal-day active"><span className="day-num">4</span></div>
              <div className="cal-day announce">
                <span className="day-num">5</span>
                <span className="cal-tag tag-announce">公告第4週</span>
              </div>
              <div className="cal-day active"><span className="day-num">6</span></div>
              <div className="cal-day active"><span className="day-num">7</span></div>
              <div className="cal-day active"><span className="day-num">8</span></div>
              <div className="cal-day deadline">
                <span className="day-num">9</span>
                <span
                  className="cal-tag tag-deadline"
                  dangerouslySetInnerHTML={{ __html: '第5週截止<br>活動結束' }}
                />
              </div>

              <div className="cal-day active"><span className="day-num">10</span></div>
              <div className="cal-day active"><span className="day-num">11</span></div>
              <div className="cal-day announce">
                <span className="day-num">12</span>
                <span className="cal-tag tag-announce">公告第5週</span>
              </div>
              <div className="cal-day empty"></div>
              <div className="cal-day empty"></div>
              <div className="cal-day empty"></div>
              <div className="cal-day empty"></div>
            </div>
            <div className="cal-legend">
              <span>
                <span
                  className="legend-dot"
                  style={{ background: '#ffd5d5', border: '1px solid #e08080' }}
                ></span>{' '}
                抽獎資格截止日（週日）
              </span>
              <span>
                <span
                  className="legend-dot"
                  style={{ background: '#c6edd9', border: '1px solid #7ecba0' }}
                ></span>{' '}
                抽獎結果公告日（週三）
              </span>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="section-label">領獎說明</div>
          <h2 className="section-title">得獎後如何領取？</h2>
          <div className="claim-grid">
            <div className="claim-card">
              <div className="claim-icon">📱</div>
              <h3>手機簡訊發送</h3>
              <p>週三抽獎完成後，系統自動傳送電子商品卡至您填寫的手機號碼，請確保號碼正確。（手機號碼、EMAIL擇一發送）</p>
            </div>
            <div className="claim-card">
              <div className="claim-icon">📧</div>
              <h3>EMAIL 發送</h3>
              <p>週三抽獎完成後，系統自動傳送電子商品卡至您填寫的電子郵件信箱，請注意查看垃圾信件匣，以免遺漏。（手機號碼、EMAIL擇一發送）</p>
            </div>
            <div className="claim-card">
              <div className="claim-icon">📢</div>
              <h3>中獎名單公告</h3>
              <p>
                中獎名單公告於 <strong>典通公司官方網站－最新消息</strong>
                <br />
                （
                <a
                  href="https://www.dsigroup.com.tw/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dsigroup.com.tw/
                </a>
                ）
              </p>
            </div>
            <div className="claim-card">
              <div className="claim-icon">⏰</div>
              <h3>資料更正說明</h3>
              <p>
                若手機號碼 或 EMAIL 因個人填寫錯誤致發送失敗，請於公告日起 <strong>7 日內</strong>來電更正，系統至多補發 2 次，逾期視同放棄。
              </p>
            </div>
          </div>

          <div className="sms-box" style={{ marginTop: '20px' }}>
            <h3>⚠️ 簡訊收不到？請先確認以下設定</h3>
            <ul className="sms-tips">
              <li>門號異常、拒收廣告簡訊、手機關機或無收訊等情形。</li>
              <li>
                已安裝 Whoscall、超級備份、黑名單-Blacklist Free、短信大師等
                APP，可能阻擋訊息。
              </li>
              <li>
                <strong>iOS：</strong>打開「訊息」App → 點左上角「編輯」→
                查看「垃圾訊息」及「最近刪除」。
              </li>
              <li>
                <strong>Android：</strong>點「訊息」App → 右上人頭圖示 →
                選擇已封鎖的垃圾訊息。
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="section-label">注意事項</div>
          <h2 className="section-title">參加前請詳閱</h2>
          <ul className="notice-list">
            <li>
              每人限填乙份問卷（以邀請信函上的樣本編號為準），參與者應保證所有資料均為真實正確。如有不實、資料缺漏、重複填答（IP／手機等）或填答時間不當，將喪失資格。
            </li>
            <li>
              同一參與者累積中獎價值超過新台幣 <strong>1,000 元</strong>
              ，依法須申報個人綜合所得稅，中獎者須配合提供身分證正反面影本，拒絕提供者視同放棄後續中獎資格。
            </li>
            <li>
              執行單位保留審核、決定及變更獎項內容之權利；如因不可抗拒因素，有權更換獎項為等值商品。
            </li>
            <li>
              因應疫情、天災、事變等不可抗力因素，執行單位保有最終修改、變更、解釋及取消本活動之權利，若有異動將另行公告。
            </li>
          </ul>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="section-label">舉辦單位</div>
          <h2 className="section-title">主辦與執行</h2>
          <div className="organizer-grid">
            <div className="org-card">
              <div className="org-role">規劃單位</div>
              <div className="org-name">衛生福利部國民健康署</div>
            </div>
            <div className="org-card">
              <div className="org-role">執行單位</div>
              <div className="org-name">典通股份有限公司</div>
              <div className="org-phone">
                客服專線：<a href="tel:0223315133">02-23315133</a> #601～604
              </div>
              <div className="org-phone" style={{ fontSize: '12px', marginTop: '4px' }}>
                服務時間：平日 09:00 – 19:00
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer>
        <strong>國民健康混合模式訪問調查—好禮週週抽活動</strong>
        <br />
        活動期間 115年7月1日至8月9日｜本活動由典通股份有限公司規劃辦理
      </footer>
    </div>
  )
}

export default Lottery
